import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';
import { titleize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
const OfferPlannerListHeaders = ({ columns, sortColumn, sortOrder, onHeaderClick, }) => {
    const { t } = useTranslation();
    return (React.createElement("tr", null, columns.map((c, index) => {
        const upChevronClassNames = classnames({
            fa: true,
            'fa-chevron-up': true,
            hidden: !c.sort,
            'font-bold': sortOrder === 'asc' && sortColumn === c.attribute,
            'text-grey': sortColumn !== c.attribute || sortOrder !== 'asc',
        });
        const downChevronClassNames = classnames({
            fa: true,
            'fa-chevron-down': true,
            hidden: !c.sort,
            'font-bold': sortOrder === 'desc' && sortColumn === c.attribute,
            'text-grey': sortColumn !== c.attribute || sortOrder !== 'desc',
        });
        const tooltip = c.columnInfo ? (React.createElement(Tooltip, { id: `column-info-${c.attribute}` }, t(c.columnInfo))) : null;
        const localeNamespace = c.localeNamespace
            ? c.localeNamespace
            : 'common';
        let headerClassNames = classnames({
            'cursor-pointer': true,
            sticky: c.pinned === true,
            'right-0': c.pinned === true,
            'bg-gray-50': c.pinned === true,
        });
        if (c.headerClassName) {
            headerClassNames = `${headerClassNames} ${c.headerClassName}`;
        }
        return (React.createElement("th", { onClick: () => onHeaderClick(c), className: headerClassNames, key: index },
            React.createElement("div", { className: "flex space-x-1 items-center" },
                React.createElement("span", { className: "font-bold text-sm" }, titleize(t(sluggify(c.name)))),
                React.createElement(OverlayTrigger, { overlay: tooltip, placement: "right" },
                    React.createElement("i", { className: "fa fa-info-circle" })),
                React.createElement("div", { className: "flex flex-col" },
                    React.createElement("i", { style: { fontSize: 10 }, className: upChevronClassNames }),
                    React.createElement("i", { style: { fontSize: 10 }, className: downChevronClassNames })))));
    })));
};
export default function OfferPlannersList({ offerPlanners, columns, userType, sortColumn, sortOrder, perPage, page, onHeaderClick, onEditActionClick, onStatusActionClick, setOfferPlanners, setConfirmationModal, }) {
    return (React.createElement("div", { className: "overflow-x-auto" },
        React.createElement("table", { className: "default-table" },
            React.createElement("thead", null,
                React.createElement(OfferPlannerListHeaders, { sortOrder: sortOrder, sortColumn: sortColumn, userType: userType, columns: columns, onHeaderClick: onHeaderClick })),
            React.createElement("tbody", null, offerPlanners.map((row, index) => {
                row.index = index;
                return (React.createElement("tr", null, columns.map((c) => {
                    const value = row[c.attribute];
                    return c.render(value, row, userType, onEditActionClick, onStatusActionClick, setOfferPlanners, setConfirmationModal);
                })));
            })))));
}
